<div red-textarea [attr.redType]="redType" [attr.control]="control" [attr.state]="state">
  <ng-content></ng-content>
</div>
